import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
export function EndState() {
  return <SectionWrapper hasDivider glowPosition="center" className="min-h-[80vh] flex flex-col justify-center" data-id="element-61">
      <div className="max-w-4xl mx-auto text-center" data-id="element-62">
        <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-white mb-8 leading-[1.1]" data-id="element-63">
          A society organized around the cultivation of sound judgment
        </h2>

        <p className="text-xl text-slate-400 leading-relaxed mb-16 max-w-3xl mx-auto" data-id="element-64">
          The broader ambition of the Cognarchic State is to create a society in
          which leadership is earned through demonstrated competence,
          citizenship is understood as a developmental process, and long-term
          stability depends on raising the quality of mind across the
          population.
        </p>

        <div className="relative inline-block group" data-id="element-65">
          <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 to-teal-500 rounded-full blur opacity-40 group-hover:opacity-60 transition duration-1000 group-hover:duration-200" data-id="element-66" />
          <div className="relative px-8 py-4 bg-[#060a14] border border-cyan-500/30 rounded-full" data-id="element-67">
            <span className="text-lg md:text-xl font-medium text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-teal-400 uppercase tracking-widest" data-id="element-68">
              The next serious political order must become cognarchic.
            </span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}